import {BffTrimData} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

export const formatTrimSelectId = (trim: BffTrimData<unknown>): string =>
  `${trim.carlineId}:::${trim.salesgroupId}:::${trim.trimId}`;

export const parseTrimSelectId = (
  id: string
): {
  carlineId: string;
  salesgroupId: string;
  trimId: string;
} => {
  const parts = id.split(':::');
  if (parts.length !== 3) {
    throw new Error('Invalid trim select id');
  }
  const [carlineId, salesgroupId, trimId] = parts;

  return {carlineId, salesgroupId, trimId};
};
